import ReactDOM from "react-dom";
export * from "react-dom";

export default ReactDOM;
